import DealsMain from 'components/featured/Deals';
import { useParams } from 'react-router-dom';

const Deals = () => {
  const params = useParams();
  const userId = params.id;

  return <DealsMain userId={userId} />;
};

export default Deals;
